import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { Program } from '../../types/content';
interface ProgramTableProps {
  items: Program[];
}
export function ProgramTable({
  items
}: ProgramTableProps) {
  return <ul className="mt-10" data-id="element-216" data-mp="rf7slse46dvk">
      <li className="rule hidden grid-cols-[1.2fr_1.6fr_auto] items-center gap-8 pb-3 pt-3 text-[0.6875rem] uppercase tracking-label text-ink-muted lg:grid" data-id="element-217" data-mp="mebuxwkcvnyl">
        <span data-id="element-218" data-mp="3uu3uu5qk3fge">Program</span>
        <span data-id="element-219" data-mp="3pusdauid85xr">What it covers</span>
        <span className="text-right" data-id="element-220" data-mp="3pvu01w8qugvb">From</span>
      </li>
      {items.map(program => <li key={program.slug} className="rule" data-id="element-221" data-mp="8mx7ndjf10lq">
          <Link to={`/programs/${program.slug}`} className="group grid items-start gap-3 py-7 transition-colors duration-150 ease-republic hover:bg-cream-deep/70 lg:grid-cols-[1.2fr_1.6fr_auto] lg:items-center lg:gap-8 lg:px-4 lg:-mx-4" data-id="element-222" data-mp="8kkiogf8ppz6">
            <div data-id="element-223" data-mp="1f27mkmv2ipoi">
              <h3 className="font-serif text-2xl leading-tight text-ink md:text-3xl" data-id="element-224" data-mp="1f4ttcka4x15o">
                {program.name}
              </h3>
              <p className="mt-2 text-[0.6875rem] uppercase tracking-label text-ink-muted" data-id="element-225" data-mp="2fv8gnzux7y5b">
                {program.category}
              </p>
            </div>
            <p className="max-w-xl text-base leading-relaxed text-ink-soft" data-id="element-226" data-mp="2ksgzm2nw867m">{program.summary}</p>
            <div className="flex items-center gap-4 lg:justify-end" data-id="element-227" data-mp="2ovdkk00woeeq">
              <span className="font-serif text-2xl text-ink" data-id="element-228" data-mp="1s6z29j01eco7">${program.priceFrom}</span>
              <span className="text-sm text-ink-muted lg:hidden" data-id="element-229" data-mp="1x47fr6a8psj4">{program.cadence}</span>
              <ArrowRightIcon className="h-5 w-5 text-brick transition-transform duration-200 ease-republic group-hover:translate-x-1" strokeWidth={1.5} data-id="element-230" data-mp="2162lqo348u38" />
            </div>
          </Link>
        </li>)}
    </ul>;
}